module.exports = __webpack_public_path__ + "static/media/ui-checks.473b92d9.svg";